function hashSeed(seed) {
  const seedString = String(seed);
  let hash = 2166136261;

  for (let i = 0; i < seedString.length; i += 1) {
    hash ^= seedString.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }

  return hash >>> 0;
}

function createSeededRng(seed) {
  let state = hashSeed(seed);

  return function rng() {
    state += 0x6D2B79F5;
    let t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

function randomInt(rng, minInclusive, maxExclusive) {
  return Math.floor(rng() * (maxExclusive - minInclusive)) + minInclusive;
}

function shuffle(items, rng) {
  const copy = [...items];

  for (let i = copy.length - 1; i > 0; i -= 1) {
    const j = randomInt(rng, 0, i + 1);
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }

  return copy;
}

function generateSeed() {
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    const values = new Uint32Array(2);
    crypto.getRandomValues(values);
    return `${values[0]}${values[1]}`;
  }

  return String(Math.floor(Math.random() * Number.MAX_SAFE_INTEGER));
}

module.exports = {
  createSeededRng,
  generateSeed,
  hashSeed,
  randomInt,
  shuffle
};
